export const XdealerLicenseCodeEnum = {
  BASE: 'base',
  PRO: 'pro',
  PRO_ALL_INCLUSIVE: 'pro_all_inclusive',
}
